<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8>
            <v-card class="elevation-12">
              <v-tabs
                  v-if="!notfound && !loading"
                  color="blue"
                  dark
                  grow
                  slider-color="yellow"
              >
                <v-tab ripple :to="'/dashboard/sensors/sensor?id=' + getID">
                  ← Volver
                </v-tab>
                <v-tab ripple :to="'/dashboard/sensors/edit?id=' + getID">
                  Datos
                </v-tab>
                <v-tab ripple :to="'/dashboard/sensors/schedules?id=' + getID">
                  Horarios
                </v-tab>
                <v-tab ripple :to="'/dashboard/sensors/building?id=' + getID">
                  Edificio
                </v-tab>
              </v-tabs>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Edificio</v-toolbar-title>
              </v-toolbar>
              <v-card-text v-if="loading">
                Cargando...
                <v-progress-linear
                    indeterminate
                    color="blue"
                    class="mb-0"
                ></v-progress-linear>
              </v-card-text>
              <v-alert v-if="notfound" :value="true" type="error" color="red">
                Sensor no encontrado.
              </v-alert>
              <v-card-text v-if="building === ''">
                <p>Este sensor no tiene ningún edificio configurado.</p>
              </v-card-text>
              <v-card-text v-if="building !== ''">
                <br/>
                <v-avatar color="grey lighten-4">
                  <v-icon>location_city</v-icon>
                </v-avatar>
                <ProfileLink
                    :key="building"
                    v-bind:idKey="building"
                    type="building"
                />
                <br/>
                <br/>
                <AddLocation
                  v-if="!loading && !notfound"
                  v-bind:idKey="building"
                  readonly
                ></AddLocation>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import AddLocation from "@/components/AddLocation.vue";
import ProfileLink from "@/components/links/ProfileLink.vue";
  import firebase from "firebase";

  let firebaseApp;
  if (!firebase.apps.length) {
    firebaseApp = firebase.initializeApp({
      apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
      authDomain: "tfgr-9ed26.firebaseapp.com",
      databaseURL: "https://tfgr-9ed26.firebaseio.com",
      projectId: "tfgr-9ed26",
      storageBucket: "tfgr-9ed26.appspot.com",
      messagingSenderId: "47742064305"
    });
  } else {
    firebaseApp = firebase.app();
  }
  export const db = firebaseApp.database();

  export default {
    components: {
      AddLocation,
      ProfileLink
    },
    data() {
      return {
        loading: true,
        notfound: false
      };
    },
    created() {
      this.$bindAsArray(
        "arrayDatos",
        db
          .ref("sensors")
          .orderByChild("key")
          .equalTo(this.getID)
          .limitToFirst(1),
        snap => {
          if (this.arrayDatos.length === 0) {
            this.notfound = true;
          }
          this.loading = false;
        },
        error => {
          if (this.arrayDatos.length === 0) {
            this.notfound = true;
          }
          this.loading = false;
        }
      );
    },
    computed: {
      getIDParameter() {
        return this.$route.query.id;
      },
      parameterIDExists() {
        if (this.$route.query.id === undefined || this.$route.query.id === null) {
          return false;
        } else {
          return true;
        }
      },
      getID() {
        if (this.parameterIDExists) {
          return this.getIDParameter;
        } else {
          return "";
        }
      },
      building() {
        if (
          this.arrayDatos[0] === null ||
          this.arrayDatos[0] === undefined ||
          this.arrayDatos[0].building === null ||
          this.arrayDatos[0].building === undefined
        ) {
          return "";
        } else {
          return this.arrayDatos[0].building;
        }
      },
      owner() {
        if (
          this.arrayDatos[0] === null ||
          this.arrayDatos[0] === undefined ||
          this.arrayDatos[0].owner === null ||
          this.arrayDatos[0].owner === undefined
        ) {
          return "";
        } else {
          return this.arrayDatos[0].owner;
        }
      }
    }
  };
</script>